import React, { useEffect, useState, useCallback } from 'react';
import './Disponibles.css';
import axios from 'axios';
import { Box, Avatar, Typography } from '@mui/material';

const Disponibles = ({ actualizarDisponibles }) => {
  const [empleados, setEmpleados] = useState([]);

  // Función para cargar los empleados desde la API
  const cargarEmpleados = useCallback(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/fichajeconEntrada`)
      .then(response => setEmpleados(response.data))
      .catch(error => console.error("Error al obtener empleados:", error));
  }, []);

  // Función para actualizar todos los datos del componente (forzar actualización)
  const actualizarFichajes = () => {
    cargarEmpleados();
  };

  // Llamar a actualizarFichajes cuando cambia 'actualizarDisponibles'
  useEffect(() => {
    actualizarFichajes();
  }, [actualizarDisponibles]);

  return (
    <Box className="d-flex gap-4 flex-wrap">
      {empleados.map((empleado) => {
        const nombreArchivo = empleado.nombre_empleado.trim();
        const imgSrc = `/fotos/${nombreArchivo}.png`;

        return (
          <Box key={empleado.id_empleado} className="text-center">
            <div className="position-relative d-inline-block">
              <Avatar
                alt={empleado.nombre_empleado}
                src={imgSrc}
                onError={(e) => e.target.src = "/fotos/avatar.png"} // fallback si no existe la imagen
                sx={{ width: 60, height: 60 }}
              />
              <span className="estado-disponible"></span>
            </div>
            <Typography variant="body2" className="empleado-nombre2">
              {empleado.nombre_empleado.split(' ')[0]}
            </Typography>
            <Typography variant="caption" className="empleado-estado">
              Disponible
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default Disponibles;
